<template>
    <div class="s2w-sequence-selector-wrap">
        <!-- eslint-disable vue/no-v-html -->
        <div
            v-if="service.rangeSelector.warning"
            class="message-tip"
            v-html="service.rangeSelector.warning"
        />
        <div class="s2w-sequence-selector">
            <div class="s2w-sequence-selector-label">
                <span>{{ $t('BaseSaveToWorkspace.sequence.selected') }}</span>
            </div>
            <div class="range-function-pane">
                <template v-if="service.enableRange">
                    <div class="use-select">
                        <div
                            class="s2w-range-radio"
                            :class="{
                                disabled: service.disabledAllType,
                                active: service.rangeSelector.selectedType === 'ALL'
                            }"
                            v-bind="disabledTooltipOption"
                            @click="changeRangeType('ALL', service.disabledAllType)"
                        >
                            <div class="s2w-range-radio__dot" />
                            <div
                                class="s2w-range-radio__content"
                            >
                                <!-- eslint-disable vue/no-v-html -->
                                <span v-html="selectAllLabel" />
                            </div>
                        </div>
                        <div class="range-container">
                            <div
                                class="s2w-range-radio no-margin"
                                :class="{
                                    disabled: service.disabledRangeType,
                                    active: service.rangeSelector.selectedType === 'RANGE'
                                }"
                                @click="changeRangeType('RANGE', service.disabledAllType)"
                            >
                                <div class="s2w-range-radio__dot" />
                                <div class="s2w-range-radio__content">
                                    <div
                                        class="range-selector"
                                        :class="{ 'is-error': service.rangeSelector.error }"
                                    >
                                        <span class="range-label">
                                            {{ $t('BaseSaveToWorkspace.RangeSelector.from') }}
                                        </span>
                                        <input
                                            class="range-input"
                                            :value="service.rangeSelector.from"
                                            :disabled="service.disabledRangeType"
                                            @blur="onRangeInputBlur($event, 'from')"
                                        >
                                        <span class="range-label">
                                            {{ $t('BaseSaveToWorkspace.RangeSelector.to') }}
                                        </span>
                                        <input
                                            class="range-input"
                                            :value="service.rangeSelector.to"
                                            :disabled="service.disabledRangeType"
                                            @blur="onRangeInputBlur($event, 'to')"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div
                                class="range-error"
                            >
                                {{ service.rangeSelector.error }}
                            </div>
                        </div>
                        <div
                            v-if="showRangeTip"
                            class="range-info"
                            :aria-label="$t('BaseSaveToWorkspace.RangeSelector.tip')"
                            data-balloon-pos="up"
                            data-balloon-white
                        >
                            <PtIcon
                                icon="SolidInfo"
                                style="font-size: 24px;"
                            />
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="use-simple">
                        <slot
                            name="simple"
                        >
                            <div v-if="sequenceName">
                                <input
                                    v-model.trim="innerSeqName"
                                    class="s2w-sequence-selector__input"
                                    type="text"
                                    @input="onNameChange"
                                >
                            </div>
                            <span v-else>
                                {{ selectedCount }} {{ $t('BaseSaveToWorkspace.sequence.selected') }}
                            </span>
                        </slot>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import isNaN from 'lodash/isNaN';

export default {
    name: 'SequenceSelector',
    inject: ['service'],
    props: {
        sequenceName: {
            type: String,
            default: '',
        },
        selectedCount: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            innerSeqName: this.sequenceName,
        };
    },
    computed: {
        allCounts() {
            return this.service.rangeSelector.allCounts;
        },
        disabledTooltipOption() {
            const tooltip = this.service.getDisabledAllTypeTooltip();
            if (!tooltip) return {};
            return {
                'aria-label': tooltip,
                'data-balloon-pos': 'up',
                'data-balloon-white': true,
            };
        },
        showRangeTip() {
            return this.service.showRangeTip;
        },
        selectAllLabel() {
            const { formatNumber } = this.service;
            return `${this.$t('BaseSaveToWorkspace.RangeSelector.selectAllLabel')} (${formatNumber(this.allCounts)})`;
        },
    },
    methods: {
        onNameChange() {
            this.$emit('update-name', this.innerSeqName);
        },
        changeRangeType(type, disabled) {
            if (disabled) return false;
            this.service.rangeSelector.selectedType = type;
            return true;
        },
        onRangeInputBlur(e, key) {
            if (!e || !e.target) return;
            const { value } = e.target;

            if (!value) {
                this.service.rangeSelector[key] = '';
                e.target.value = this.service.rangeSelector[key];
                return;
            }

            const newValue = parseInt(value, 10);

            if (!isNaN(newValue)) {
                const { min } = this.service.rangeSelector;
                this.service.rangeSelector[key] = Math.max(min, newValue);
            }
            e.target.value = this.service.rangeSelector[key];
        },
    },
};
</script>
